import Main from '@/layouts/Main.vue'
import Dashboard from '../views/Dashboard.vue'
import Pass from '../views/Pass.vue'
 
const routes = [
    {
        path: '/dashboard',
        component: Main,
        children: [
            {
                path: '',
                name: 'Dashboard',
                component: Dashboard,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'pass',
                component: Pass,
                name: 'LifePass',
                meta: {
                    requiresAuth: true
                }
            }
        ]
    }
]

export default routes